import { EmitterVisitorContext } from '@angular/compiler';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Type, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedFormService } from 'src/app/shared-utility/services/shared-form.service';

@Component({
  selector: 'app-physician-locale-form',
  templateUrl: './physician-locale-form.component.html',
  styleUrls: ['./physician-locale-form.component.scss']
})
export class PhysicianLocaleFormComponent implements OnInit {

  
 
  @Input() formGroup: FormGroup;
  @Input() dynamicForm: any;
  @Input() currentPos: number;
  @Input() officeName: string;
  @Input() rank: number;
  @Output() addLocale = new EventEmitter();
  @Output() removeLocale = new EventEmitter();
  @Output() setIsPrimary = new EventEmitter();
  @Output() unSetPrimary = new EventEmitter();
  

  screenHeight: number;
  screenWidth: number;
  txtWidthTop = 47;
  txtWidthCity = 35;
  txtOfficeName = 48;
  txtEmail = 38;
  cardHeader = "Practice";
  chkIsPrimary: boolean = false;

  statesLs: string[];
  blnShowStates: boolean = false;
  @ViewChild('stateRef', {static: false}) stateRef: ElementRef;

  constructor(private fb: FormBuilder, private formSvc: SharedFormService) { 
    this.statesLs = this.formSvc.getStatesData();
  }

  ngOnInit() {
    const office = this.officeName ? this.officeName : '';
    this.cardHeader = office ? this.cardHeader + ' - ' + office : this.cardHeader ;
    this.chkIsPrimary = this.rank === 1;
    this.sendPrimary();
    // this.formSvc.addToFormGroup(this.formGroup, this.dynamicForm);
    this.getScreenSize();
  }
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
       
       if( this.screenWidth <= 1024){
            this.txtWidthTop = 40;
            this.txtWidthCity = 24;
            this.txtOfficeName = 32;
            this.txtEmail = 30;

        } else if ( this.screenWidth > 1024) {
          this.txtWidthTop = 47;
          this.txtWidthCity = 35;
          this.txtOfficeName = 48;
          this.txtEmail = 38;
        }
  }
  showStates(): void{
    this.blnShowStates = !this.blnShowStates;
  }
  stateSelected(e: any): void {
  
   this.stateRef.nativeElement.innerHTML = e.srcElement.innerHTML;
   this.blnShowStates = false;
   this.formGroup.get('state').setValue(e.srcElement.innerHTML);
  }
  addNewLocale(): void {
    
    this.addLocale.emit(this.currentPos);
  }
  removeNewLocale(): void {
    this.removeLocale.emit(this.currentPos);
  }
  sendPrimary(): void {
    const emailKey = this.findFormKey('emailAddress');
    if(this.chkIsPrimary) {
      this.setIsPrimary.emit(emailKey);
    } else {
      this.unSetPrimary.emit(emailKey);
    }
  }
  findFormKey(starts: string): string {
   
    let keyFound = '';
    for( let key in this.dynamicForm) {
      
      if(this.dynamicForm.hasOwnProperty(key)) {
        if (key.startsWith(starts)) {
          
          keyFound = key;
          break;
        }
      }
    }
    return keyFound;
  }

}
